const autoNgTemplateLoaderTemplate1 = require('./endpointList.html');

angular.module('portainer.app').component('endpointList', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'EndpointListController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    tags: '<',
    tableKey: '@',
    dashboardAction: '<',
    snapshotAction: '<',
    showSnapshotAction: '<',
    editAction: '<',
    isAdmin: '<',
    retrievePage: '<',
    endpointInitTime: '<',
  },
});
